import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useDisconnectApollo(tenant: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axios.delete(`${getBongoUrl()}/v1/org/${tenant}/integrations/apollo`);
    },
    onSuccess: () => {
      queryClient.setQueryData(['apollo', tenant], false);
    },
  });
}
